import { GCC_QUICK_WIN_LABEL, GCC_QUICK_WIN_OFF_SUMMARY, quickWinBasis } from '@tn/shared'
import { GCC_BADGE } from './gccExecutiveStyle'

/** Full text of a quick-win badge: "Quick win – agentify first: Low complexity · 4 months ≤ 6-month horizon" (WI 2806). */
export function quickWinTitle(monthsToImplement: number, horizonMonths: number): string {
  return `${GCC_QUICK_WIN_LABEL}: ${quickWinBasis(monthsToImplement, horizonMonths)}`
}

/**
 * "3 quick wins: low-complexity Automate / Agentify tasks live within 6 months, agentified first",
 * or that quick wins are off for a 0-month horizon (WI 2886).
 */
export function quickWinSummary(count: number, horizonMonths: number): string {
  if (horizonMonths === 0) return GCC_QUICK_WIN_OFF_SUMMARY
  return `${count} quick win${count === 1 ? '' : 's'}: low-complexity Automate / Agentify tasks live within ${horizonMonths} months, agentified first`
}

/**
 * Quick-win badge of one task (WI 2806). The basis is in its title and accessible
 * name, so hovering, focus and screen readers all get it.
 */
export function QuickWinBadge({ monthsToImplement, horizonMonths, className = '' }: {
  monthsToImplement: number
  horizonMonths: number
  className?: string
}) {
  const title = quickWinTitle(monthsToImplement, horizonMonths)
  return (
    <span
      className={`gx-badge ${className}`.trim()}
      style={{ background: GCC_BADGE.green.bg, color: GCC_BADGE.green.text }}
      title={title}
      aria-label={title}
    >
      Quick win
    </span>
  )
}
